import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TextInputDataComponent } from '../../../components/text-input/text-input.component';
import { SelectComponent } from '../../../components/select/select.component';
import { HandleBookingService } from '../../../services/handle-booking.service';
import { RadioBtnComponent } from '../../../components/radio-btn/radio-btn.component';
import { ParkingRepo } from '../../../repo/parking.repo';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmModalComponent } from '../../../components/confirm-modal/confirm-modal.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { EmailInputFieldComponent } from '../../../components/email-input-field/email-input-field.component';
import { PhoneNumberInputComponent } from '../../../components/phone-number-input/phone-number-input.component';
import { CommonModule } from '@angular/common';
import { FormService } from '../../../organizations/features/booking/components/form/service';
import {
  MatDialog,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { ModalConfirmServiceCancelComponent } from '../../../components/modal-confirm-service-cancel/modal-confirm-service-cancel.component';
import { BookingSummaryCardComponent } from '../../../components/booking-summary-card/booking-summary-card.component';
import { BookingConfigService } from '../../../services/booking-config.service';
import { FormGroup } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { BackOfficeService } from '../../../../services/backoffice.service';
import { CheckoutServices } from '../../../services/checkout.service';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';

@Component({
  selector: 'app-handle-booking-details',
  imports: [
    RouterLink,
    TextInputDataComponent,
    SelectComponent,
    RadioBtnComponent,
    TranslocoModule,
    EmailInputFieldComponent,
    PhoneNumberInputComponent,
    CommonModule,
    BookingSummaryCardComponent,
    MatProgressBarModule,
    MatListModule,
    MatIconModule
  ],
  templateUrl: './handle-booking-details.component.html',
  styleUrl: './handle-booking-details.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [HandleBookingService]
})
export class HandleBookingDetailsComponent {
  handleBookingStatus: 'error' | 'updated' | '' = '';
  handleBookingGroup: any;
  email: string | null = "";
  bookingNumber: string | null = "";
  arrivalParkingOptions = [
    { value: '', viewValue: '' },
  ];
  parkingFrom: any;
  site: string = ""
  booking: any = null; // SelfServiceModel
  checkInBagage: any = []
  additionalServices: any;
  orderId: any = null;
  passengers = [
    { value: '1', viewValue: '1' },
    { value: '2', viewValue: '2' },
    { value: '3', viewValue: '3' },
    { value: '4', viewValue: '4' },
    { value: '5', viewValue: '5' },
    { value: '6', viewValue: '6' },
    { value: '7', viewValue: '7' },
    { value: '8', viewValue: '8' },
  ]
  parkType: string = '';
  freeShuttles: boolean = false;
  bookingDetails: any = {  // This should not be used, all data should be in SelfServiceModel (this.booking)
    order: null,
    parking: null,
    shuttles: [],
    additionalServices: []
  };
  form !: FormService;
  parkingType!: string;
  details !: FormGroup;
  parkingGroup: any;
  departureHotel: any;
  arrivalHotel: any;
  bookingLoaded: boolean = false;
  activeLang: string = 'sv';
  officeAddress: string = 'Matchedin AB, org.nr: 559013-7716 Wallingatan 42, 111 24 Stockholm';
  isLoading: boolean = false;
  isParkingPermitUser: boolean = false;
  parkingNames: any = {
    "677844ae-bb01-4265-bfde-32264410ed09": 'P_49', //p2 inomus
    "453f945a-ee11-4d75-8265-b16f00e5f04b": 'P_41', //p1 storbil
    "f9e5d6c3-4419-4c61-a290-b16f00e5e500": 'P_40', //el bil
    "8c98315a-b2ad-4e70-86f9-5d54992fed26": 'P_39', //Långtidsparkering,
    "697844ae-bb01-4265-bfde-32264410ed09": 'P_67', //VIP
    "c797769e-66bf-4283-96c5-b16f00e5e126": 'P_1',
    "eacc8615-81a4-4013-a7e5-b16f00e5e270": 'P_6',
    "1a8879f4-a294-455b-97eb-b16f00e5e30a": 'P_12',
    "5d2c7728-6944-45a6-a64e-b16f00e5e3b3": 'P_18',
    "8d922482-7855-47dc-953b-b16f00e5e45a": 'P_24'
  }
  organizationId: string = 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';
  allAdditionalServices: any = [];
  isEditable: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private handleBookingService: HandleBookingService,
    private parkingRepo: ParkingRepo,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private translocoService: TranslocoService,
    private bookingConfigService: BookingConfigService,
    private _formService: FormService,
    public backofficeService: BackOfficeService,
    private checkoutService: CheckoutServices
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
  }

  openConfirmModal() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {});

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cancelOrder();
      }
    });
  }

  openModalConfirmServiceCancel() {
    const dialogRef = this.dialog.open(ModalConfirmServiceCancelComponent, {});

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cancelServices();
      }
    });

  }

  cancelServices() {

    this.handleBookingService.cancelAdditionalServices(
      this.bookingNumber ? this.bookingNumber : '',
      this.email ? this.email : '',
    )
      .then((model) => {
        this.bookingDetails.additionalServices = [];
        this._snackBar.open("Tillvalen är avbokade", 'Stäng', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }).catch((error) => {
        console.error(error);
      });
  }

  cancelOrder() {
    this.handleBookingService.cancelByOrderNumberEmail(
      this.bookingNumber ? this.bookingNumber : '',
      this.email ? this.email : '',
    )
      .then((model) => {
        if (model.result != "CanceledOrder") {
          this._snackBar.open("Det gick inte att avboka din bokning just nu då betalningen inte nått oss ännu, var vänlig och försök igen senare eller kontakta supporten.", 'Stäng',
            {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
        }
        if (model.result == "CanceledOrder") {
          this._snackBar.open("Din avbokning är genomförd", 'Stäng', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.router.navigate(['/parkifly/handle-booking']);
        }
      }).catch((error) => {
        console.error(error);
      });
  }

  updateBooking() {
    const form = this.handleBookingService.getForm().value;
    var updates;

    // const updatedAdditionalServices = this.allAdditionalServices
    //   .filter((service: any) => service.planned === true)
    //   .map((service: any) => ({
    //     ...service,
    //     planned: null,
    //     status: 'Planned'
    //   }));

    if (this.site === 'flygets') {
      var timeFromForm = form.details.arrivalTimeAtParking;
      var hoursFromForm = timeFromForm.charAt(0) == 0 ? timeFromForm.substring(1, 2) : timeFromForm.substring(0, 2);
      var minutesFromForm = timeFromForm.charAt(3) == 0 ? timeFromForm.substring(4) : timeFromForm.substring(3);
      var newParkingFrom = new Date(this.parkingFrom);
      newParkingFrom.setHours(hoursFromForm, minutesFromForm)
      if (this.parkingFrom < newParkingFrom) {
        newParkingFrom.setDate(newParkingFrom.getDate() - 1);
      }

      // if (this.isEditable) {
      //   updates = {
      //     orderNumber: this.bookingNumber ? this.bookingNumber : '',
      //     email: this.email ? this.email : '',
      //     cellular: form.details.cellular,
      //     comment: form.details.comment,
      //     carRegNumber: form.details.regNr,
      //     passengers: form.details.persons,
      //     contact: form.details.contact ? (form.details.contact == 'true' ? true : false) : false,
      //     newParkingFrom: newParkingFrom.toISOString(),
      //     additionalServices: updatedAdditionalServices
      //   }
      // } else {
      updates = {
        orderNumber: this.bookingNumber ? this.bookingNumber : '',
        email: this.email ? this.email : '',
        cellular: form.details.cellular,
        comment: form.details.comment,
        carRegNumber: form.details.regNr,
        passengers: form.details.persons,
        contact: form.details.contact ? (form.details.contact == 'true' ? true : false) : false,
        newParkingFrom: newParkingFrom.toISOString(),
      }
      // }

    }
    else if (this.site === 'mdpark') {
      var timeFromForm = form.details.arrivalTimeAtParking;
      var hoursFromForm = timeFromForm.charAt(0) == 0 ? timeFromForm.substring(1, 2) : timeFromForm.substring(0, 2);
      var minutesFromForm = timeFromForm.charAt(3) == 0 ? timeFromForm.substring(4) : timeFromForm.substring(3);
      var newParkingFrom = new Date(this.parkingFrom);
      newParkingFrom.setHours(hoursFromForm, minutesFromForm)
      if (this.parkingFrom < newParkingFrom) {
        newParkingFrom.setDate(newParkingFrom.getDate() - 1);
      }

      updates = {
        orderNumber: this.bookingNumber ? this.bookingNumber : '',
        email: this.email ? this.email : '',
        cellular: form.details.cellular,
        comment: form.details.comment,
        carRegNumber: form.details.regNr,
        passengers: form.details.persons,
        contact: form.details.contact ? (form.details.contact == 'true' ? true : false) : false,
        newParkingFrom: newParkingFrom.toISOString(),
      }
    }
    else if (this.site === 'skavsta') {
      updates = {
        orderNumber: this.bookingNumber ? this.bookingNumber : '',
        email: this.email ? this.email : '',
        cellular: form.details.cellular,
        // comment: form.details.comment,
        carRegNumber: form.details.regNr,
        // contact: form.details.contact ? (form.details.contact == 'true' ? true : false) : false,
        newParkingFrom: this.booking.parkingFrom,
        passengers: form.details.persons
      }
    }

    this.handleBookingService.updateBookingDetails(updates).subscribe(payment => {
      this._snackBar.open("Bokningen är uppdaterad", 'Stäng', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  openTermsModal() {
    this.dialog.open(TermsModal, {
      maxHeight: '85vh',
      panelClass: 'terms-modal-dialog'
    });
  }

  openHandBagageModal() {
    this.dialog.open(HandBagageModal);
  }

  regToUpper() {
    this.handleBookingGroup.controls["regNr"].setValue(this.handleBookingGroup.controls["regNr"]._pendingValue.toUpperCase());
  }

  public ngOnInit() {
    this.isLoading = true;
    this.activeLang = this.translocoService.getActiveLang();
    this.translocoService.langChanges$.subscribe((lang) => {
      this.activeLang = lang;
    });
    this.translocoService.selectTranslate('PARKIFLY.PLACEHOLDER.1_HOUR_BEFORE')
      .subscribe(value => {
        this.checkInBagage = [
          { value: '1', viewValue: this.translocoService.translate("PARKIFLYFORM.YES") },
          { value: '0', viewValue: this.translocoService.translate("PARKIFLY.SUMMARY.ONLY_CARRYON_LUGGAGE_OPTION") },
        ]
      });

    this.route.paramMap.subscribe(params => {
      this.email = params.get("email");
      this.bookingNumber = params.get("booking_number");
      if (this.email && this.bookingNumber) {
        this.router.navigate(['parkifly/booking-overview', { email: this.email, booking_number: this.bookingNumber }]);
      } else {
        this.router.navigate(['/parkifly/handle-booking']);
      }
    });
  }

  addOrderAdditionalService() {
    this.isEditable = true;
  }

  removeAdditionalService() {
    this.isEditable = false;
  }

  getAdditionalServices() {
    this.backofficeService
      .getOrganizationAdditionalServices(this.organizationId)
      .subscribe(allServices => {
        const bookedServices = this.bookingDetails.additionalServices || [];

        // Iterate through all additional services
        this.allAdditionalServices = allServices.map((service: any) => {

          if (typeof service.name === 'string') {
            service.name = JSON.parse(service.name);
          }

          const isPlanned = bookedServices.some(
            booked => booked.name?.sv === service.name?.sv
          );

          return {
            ...service,
            planned: isPlanned
          };
        });

        this.allAdditionalServices.sort((a, b) => {
          return (b.planned === true ? 1 : 0) - (a.planned === true ? 1 : 0);
        });
      });
  }

  onServiceSelectionChange(event: any) {
    const selectedServices = event.source.selectedOptions.selected.map(option => option.value);
    this.allAdditionalServices.forEach(service => {
      service.planned = selectedServices.includes(service);
    });
  }

  isOtherServiceActive(currentService: any): boolean {
    return this.allAdditionalServices.some(
      service =>
        service !== currentService &&
        service.name?.en !== 'Submission of key' &&
        service.planned
    );
  }

  goToPaymentPage() {
    this.router.navigate(['parkifly', this.site, 'checkout', 'payment', this.orderId]);
  }

  downloadPdf() {
    this.checkoutService.downloadReceipt(this.orderId).subscribe(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'receipt.pdf';
      a.click();
    });
  }

}

@Component({
  selector: 'terms-modal',
  templateUrl: 'terms-modal.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, MatDialogContent, TranslocoModule, MatDialogActions, MatDialogClose, TermsAndConditionsComponent]
})
export class TermsModal {
  constructor() { }
}

@Component({
  selector: 'hand-bagage-modal',
  templateUrl: 'hand-bagage-modal.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, MatDialogContent, TranslocoModule, MatDialogActions, MatDialogClose]
})
export class HandBagageModal {
  constructor() { }
}
